import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useState, useRef } from "preact/hooks";
import { sortOptions } from "../config"

export default () => {
    const [ sortOpen, setSortOpen ] = useState(false);
    const { activeSort, setSort } = useSort(sortOptions);
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }));
    const buttonRef = useRef(null);

    const toggleSortDropdown = ( event ) => {
        event.preventDefault();
        event.stopImmediatePropagation();

        const button = buttonRef.current;
        button.style.width = `${button.clientWidth}px`;
    
        let newWidth = null;
        const optsBox = button.nextElementSibling;
        
        if (!sortOpen) {
            newWidth = optsBox.clientWidth;
            newWidth += parseInt(getComputedStyle(optsBox).right, 10);
            newWidth -= parseInt(getComputedStyle(optsBox.querySelector('.link-dropdown__link')).paddingInlineStart, 10);
        } else {
            newWidth = parseInt(getComputedStyle(button).paddingInlineEnd, 10) +
                Math.ceil(button.querySelector('.link-dropdown__button-text').getBoundingClientRect().width);
        }
            
        setTimeout(() => {
            button.style.width = `${newWidth}px`;
        }, 10);    
        setSortOpen(prevSortOpen => !prevSortOpen);
        
    }


    const handleSortChange = (value) => {
        setSort(value);
        setSortOpen(false);
    }

    return (
        <div class="link-dropdown link-dropdown--right-aligned">
            <div class="visually-hidden" id="sort-dropdown-heading">Sort by</div>

            <button
                class="link-dropdown__button has-motion"
                aria-describedby="sort-dropdown-heading"
                aria-controls="sort-dropdown-options"
                type="button"
                aria-expanded={sortOpen}
                onClick={toggleSortDropdown}
                ref={buttonRef}
            >
                <span class="link-dropdown__button-text">{options.find(option => option.value === activeSort)?.label}</span>
                <span class="link-dropdown__button-icon has-motion">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="icon feather feather-chevron-down" aria-hidden="true" focusable="false" role="presentation">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                </span>
            </button>

            <div class="link-dropdown__options" id="sort-dropdown-options">
                {options.map(option => (
                    <button 
                        key={option.value} 
                        class={`link-dropdown__link ${activeSort === option.value ? 'link-dropdown__link--active' : ''}`} 
                        onClick={() => handleSortChange(option.value)}
                        type="button"
                    >
                        {option.label}
                    </button>
                ))}
            </div>
        </div>
    )
}